import { DisplayTheme, DisplayThemeValueSet } from '../../types';
import { BASE_COLORS, U_ALPHA_DARK, U_ALPHA_LIGHT } from './baseColors';

export type BookwiseComponents = {
  infoPanelAuthorIcon: DisplayThemeValueSet;
  placeholderIconColor: DisplayThemeValueSet;
  placeholderBookBg: DisplayThemeValueSet;
  nowReadingColor: DisplayThemeValueSet;
  relatedSessionTimeColor: DisplayThemeValueSet;
  feedItemAccentColour: DisplayThemeValueSet;
  bookCardBackground: DisplayThemeValueSet;
  badgeTextColor: DisplayThemeValueSet;
  avatarBackground: DisplayThemeValueSet;
  initialsTextColor: DisplayThemeValueSet;
  leaderboardWeeklyXpGain: DisplayThemeValueSet;
  gainBackground: DisplayThemeValueSet;
  leaderboardGradientOpacity: DisplayThemeValueSet<number>;
  leaderboardGradientStartColor: DisplayThemeValueSet;
  leaderboardPlaceTextColors: DisplayThemeValueSet<string[]>;
  leaderboardWreathColors: DisplayThemeValueSet<string[]>;
  statWordBackground: DisplayThemeValueSet;
  statTimeBackground: DisplayThemeValueSet;
  statHighlightBackground: DisplayThemeValueSet;
  backgroundStrong: DisplayThemeValueSet;
  inputError: DisplayThemeValueSet;
  keyboardInputBackground: DisplayThemeValueSet;
  bgSelectedEmoji: DisplayThemeValueSet;
  panelBackground: DisplayThemeValueSet;
  panelBorder: DisplayThemeValueSet;
  dividerTop: DisplayThemeValueSet;
  dividerBottom: DisplayThemeValueSet;
  navBorder: DisplayThemeValueSet;
  navBackground: DisplayThemeValueSet;
  reactionBG: DisplayThemeValueSet;
  progressPrimarySession: DisplayThemeValueSet;
  progressSecondarySession: DisplayThemeValueSet;
  progressInsetBorder: DisplayThemeValueSet;
  shelfCurrentlyReading: DisplayThemeValueSet;
  shelfWantToRead: DisplayThemeValueSet;
  shelfFinished: DisplayThemeValueSet;
  shelfDidNotFinish: DisplayThemeValueSet;
  currentlyReadingRibbon: DisplayThemeValueSet;
  sampleRibbon: DisplayThemeValueSet;
  dnfRibbon: DisplayThemeValueSet;
  finishedRibbon: DisplayThemeValueSet;
  kindleRibbon: DisplayThemeValueSet;
  textXP: DisplayThemeValueSet;
  xpPillBackground: DisplayThemeValueSet;
  buttonBackgroundNeutral: DisplayThemeValueSet;
  buttonBackgroundNeutralDisabled: DisplayThemeValueSet;
  buttonBackgroundNeutralSubtle: DisplayThemeValueSet;
  buttonBackgroundNeutralSubtleDisabled: DisplayThemeValueSet;
  buttonBackgroundAccent: DisplayThemeValueSet;
  buttonBackgroundAccentDisabled: DisplayThemeValueSet;
  buttonBackgroundAccentSubtle: DisplayThemeValueSet;
  buttonBackgroundAccentSubtleDisabled: DisplayThemeValueSet;
  buttonTextNeutral: DisplayThemeValueSet;
  buttonTextNeutralDisabled: DisplayThemeValueSet;
  buttonTextNeutralSubtle: DisplayThemeValueSet;
  buttonTextNeutralSubtleDisabled: DisplayThemeValueSet;
  buttonTextAccent: DisplayThemeValueSet;
  buttonTextAccentDisabled: DisplayThemeValueSet;
  buttonTextAccentSubtle: DisplayThemeValueSet;
  buttonTextAccentSubtleDisabled: DisplayThemeValueSet;
  utilityBlueAlpha50: DisplayThemeValueSet;
  utilityBlueAlpha60: DisplayThemeValueSet;
  utilityBlueAlpha70: DisplayThemeValueSet;
  utilityBlueAlpha80: DisplayThemeValueSet;
  utilityBlueAlpha90: DisplayThemeValueSet;
  utilityEmeraldAlpha50: DisplayThemeValueSet;
  utilityEmeraldAlpha60: DisplayThemeValueSet;
  utilityEmeraldAlpha70: DisplayThemeValueSet;
  utilityEmeraldAlpha80: DisplayThemeValueSet;
  utilityEmeraldAlpha90: DisplayThemeValueSet;
  utilityGreenAlpha50: DisplayThemeValueSet;
  utilityGreenAlpha60: DisplayThemeValueSet;
  utilityGreenAlpha70: DisplayThemeValueSet;
  utilityGreenAlpha80: DisplayThemeValueSet;
  utilityGreenAlpha90: DisplayThemeValueSet;
  utilityNeutralAlpha50: DisplayThemeValueSet;
  utilityNeutralAlpha60: DisplayThemeValueSet;
  utilityNeutralAlpha70: DisplayThemeValueSet;
  utilityNeutralAlpha80: DisplayThemeValueSet;
  utilityNeutralAlpha90: DisplayThemeValueSet;
  utilityOrangeAlpha50: DisplayThemeValueSet;
  utilityOrangeAlpha60: DisplayThemeValueSet;
  utilityOrangeAlpha70: DisplayThemeValueSet;
  utilityOrangeAlpha80: DisplayThemeValueSet;
  utilityOrangeAlpha90: DisplayThemeValueSet;
  utilityRedAlpha50: DisplayThemeValueSet;
  utilityRedAlpha60: DisplayThemeValueSet;
  utilityRedAlpha70: DisplayThemeValueSet;
  utilityRedAlpha80: DisplayThemeValueSet;
  utilityRedAlpha90: DisplayThemeValueSet;
  utilityStoneAlpha50: DisplayThemeValueSet;
  utilityStoneAlpha60: DisplayThemeValueSet;
  utilityStoneAlpha70: DisplayThemeValueSet;
  utilityStoneAlpha80: DisplayThemeValueSet;
  utilityStoneAlpha90: DisplayThemeValueSet;
  highlightText: DisplayThemeValueSet;
  highlightBackground: DisplayThemeValueSet;
  highlightBorder: DisplayThemeValueSet;
  highlightTextExternal: DisplayThemeValueSet;
  highlightBackgroundExternal: DisplayThemeValueSet;
  highlightBorderExternal: DisplayThemeValueSet;
  buttonAccentStrongBackground: DisplayThemeValueSet;
  buttonAccentStrongBackgroundHover: DisplayThemeValueSet;
  buttonAccentStrongBackgroundPressed: DisplayThemeValueSet;
  buttonAccentStrongBackgroundDisabled: DisplayThemeValueSet;
  buttonAccentStrongText: DisplayThemeValueSet;
  buttonAccentStrongTextDisabled: DisplayThemeValueSet;
  buttonAccentStrongIcon: DisplayThemeValueSet;
  buttonAccentSubtleBackground: DisplayThemeValueSet;
  buttonAccentSubtleBackgroundHover: DisplayThemeValueSet;
  buttonAccentSubtleBackgroundPressed: DisplayThemeValueSet;
  buttonAccentSubtleBackgroundDisabled: DisplayThemeValueSet;
  buttonAccentSubtleText: DisplayThemeValueSet;
  buttonAccentSubtleTextDisabled: DisplayThemeValueSet;
  buttonAccentSubtleIcon: DisplayThemeValueSet;
  buttonAccentGhostBackground: DisplayThemeValueSet;
  buttonAccentGhostBackgroundHover: DisplayThemeValueSet;
  buttonAccentGhostBackgroundPressed: DisplayThemeValueSet;
  buttonAccentGhostBackgroundDisabled: DisplayThemeValueSet;
  buttonAccentGhostText: DisplayThemeValueSet;
  buttonAccentGhostTextDisabled: DisplayThemeValueSet;
  buttonAccentGhostIcon: DisplayThemeValueSet;
  buttonNeutralStrongBackground: DisplayThemeValueSet;
  buttonNeutralStrongBackgroundHover: DisplayThemeValueSet;
  buttonNeutralStrongBackgroundPressed: DisplayThemeValueSet;
  buttonNeutralStrongBackgroundDisabled: DisplayThemeValueSet;
  buttonNeutralStrongText: DisplayThemeValueSet;
  buttonNeutralStrongIcon: DisplayThemeValueSet;
  buttonNeutralSubtleBackground: DisplayThemeValueSet;
  buttonNeutralSubtleBackgroundHover: DisplayThemeValueSet;
  buttonNeutralSubtleBackgroundPressed: DisplayThemeValueSet;
  buttonNeutralSubtleBackgroundDisabled: DisplayThemeValueSet;
  buttonNeutralSubtleText: DisplayThemeValueSet;
  buttonNeutralSubtleIcon: DisplayThemeValueSet;
  buttonNeutralGhostBackground: DisplayThemeValueSet;
  buttonNeutralGhostBackgroundHover: DisplayThemeValueSet;
  buttonNeutralGhostBackgroundPressed: DisplayThemeValueSet;
  buttonNeutralGhostBackgroundDisabled: DisplayThemeValueSet;
  buttonNeutralGhostText: DisplayThemeValueSet;
  buttonNeutralGhostIcon: DisplayThemeValueSet;
  // Button Critical Strong
  buttonCriticalStrongBackground: DisplayThemeValueSet;
  buttonCriticalStrongBackgroundHover: DisplayThemeValueSet;
  buttonCriticalStrongBackgroundPressed: DisplayThemeValueSet;
  buttonCriticalStrongBackgroundDisabled: DisplayThemeValueSet;
  buttonCriticalStrongText: DisplayThemeValueSet;
  buttonCriticalStrongIcon: DisplayThemeValueSet;
  buttonCriticalSubtleBackground: DisplayThemeValueSet;
  buttonCriticalSubtleBackgroundHover: DisplayThemeValueSet;
  buttonCriticalSubtleBackgroundPressed: DisplayThemeValueSet;
  buttonCriticalSubtleBackgroundDisabled: DisplayThemeValueSet;
  buttonCriticalSubtleText: DisplayThemeValueSet;
  buttonCriticalSubtleIcon: DisplayThemeValueSet;
  // Button Critical Ghost
  buttonCriticalGhostBackground: DisplayThemeValueSet;
  buttonCriticalGhostBackgroundHover: DisplayThemeValueSet;
  buttonCriticalGhostBackgroundPressed: DisplayThemeValueSet;
  buttonCriticalGhostBackgroundDisabled: DisplayThemeValueSet;
  buttonCriticalGhostText: DisplayThemeValueSet;
  buttonCriticalGhostIcon: DisplayThemeValueSet;
};

export const BOOKWISE_COMPONENTS: BookwiseComponents = {
  xpPillBackground: {
    [DisplayTheme.Light]: 'rgba(123, 122, 121, 0.08)',
    [DisplayTheme.Dark]: 'rgba(123, 122, 121, 0.28)',
  },
  textXP: {
    [DisplayTheme.Light]: '#FF6900',
    [DisplayTheme.Dark]: '#FFB86A',
  },
  infoPanelAuthorIcon: {
    [DisplayTheme.Light]: '#F2F3F3',
    [DisplayTheme.Dark]: '#232B34',
  },
  placeholderIconColor: {
    [DisplayTheme.Light]: '#ccc',
    [DisplayTheme.Dark]: '#ccc',
  },
  placeholderBookBg: {
    [DisplayTheme.Light]: '#f8f8f8',
    [DisplayTheme.Dark]: '#f8f8f8',
  },
  nowReadingColor: {
    [DisplayTheme.Light]: BASE_COLORS.orange50,
    [DisplayTheme.Dark]: BASE_COLORS.orange50,
  },
  relatedSessionTimeColor: {
    [DisplayTheme.Light]: '#555',
    [DisplayTheme.Dark]: '#555',
  },
  feedItemAccentColour: {
    [DisplayTheme.Light]: '#F5906B',
    [DisplayTheme.Dark]: '#F5906B',
  },
  badgeTextColor: {
    [DisplayTheme.Light]: BASE_COLORS.white,
    [DisplayTheme.Dark]: BASE_COLORS.white,
  },
  bookCardBackground: {
    [DisplayTheme.Light]: BASE_COLORS.white,
    [DisplayTheme.Dark]: BASE_COLORS.black,
  },
  avatarBackground: {
    [DisplayTheme.Light]: BASE_COLORS.sepia300,
    [DisplayTheme.Dark]: BASE_COLORS.blue80,
  },
  initialsTextColor: {
    [DisplayTheme.Light]: BASE_COLORS.stone600,
    [DisplayTheme.Dark]: BASE_COLORS.blue30,
  },
  leaderboardWeeklyXpGain: {
    [DisplayTheme.Light]: BASE_COLORS.green50bw,
    [DisplayTheme.Dark]: BASE_COLORS.green50bw,
  },
  gainBackground: {
    [DisplayTheme.Light]: '#43AC4733',
    [DisplayTheme.Dark]: '#43AC4733',
  },
  leaderboardGradientOpacity: {
    [DisplayTheme.Light]: 1,
    [DisplayTheme.Dark]: 0.1,
  },
  leaderboardGradientStartColor: {
    [DisplayTheme.Light]: BASE_COLORS.white,
    [DisplayTheme.Dark]: BASE_COLORS.black,
  },
  leaderboardPlaceTextColors: {
    [DisplayTheme.Light]: ['#8F5F05', '#616161', '#8E5010'],
    [DisplayTheme.Dark]: ['#8F5F05', '#616161', '#8E5010'],
  },
  leaderboardWreathColors: {
    [DisplayTheme.Light]: ['#EEB63D', '#AAAAAA', '#E7913C', '#000000'],
    [DisplayTheme.Dark]: ['#EEB63D', '#AAAAAA', '#E7913C', '#FFFFFF'],
  },
  backgroundStrong: {
    [DisplayTheme.Light]: BASE_COLORS.white,
    [DisplayTheme.Dark]: BASE_COLORS.black,
  },
  inputError: {
    [DisplayTheme.Light]: BASE_COLORS.red50,
    [DisplayTheme.Dark]: BASE_COLORS.red50,
  },
  statWordBackground: {
    [DisplayTheme.Light]: BASE_COLORS.orange400,
    [DisplayTheme.Dark]: BASE_COLORS.orange400,
  },
  statHighlightBackground: {
    [DisplayTheme.Light]: BASE_COLORS.yellow300,
    [DisplayTheme.Dark]: BASE_COLORS.yellow300,
  },
  statTimeBackground: {
    [DisplayTheme.Light]: BASE_COLORS.emerald500,
    [DisplayTheme.Dark]: BASE_COLORS.emerald500,
  },
  keyboardInputBackground: {
    [DisplayTheme.Light]: BASE_COLORS.white,
    [DisplayTheme.Dark]: BASE_COLORS.neutral10,
  },
  bgSelectedEmoji: {
    [DisplayTheme.Light]: BASE_COLORS.orange70,
    [DisplayTheme.Dark]: BASE_COLORS.orange400,
  },
  panelBackground: {
    [DisplayTheme.Light]: BASE_COLORS.stone100,
    [DisplayTheme.Dark]: BASE_COLORS.stone13,
  },
  panelBorder: {
    [DisplayTheme.Light]: BASE_COLORS.stone90,
    [DisplayTheme.Dark]: BASE_COLORS.stone15,
  },
  dividerTop: {
    [DisplayTheme.Light]: BASE_COLORS.stone90,
    [DisplayTheme.Dark]: BASE_COLORS.stone00,
  },
  dividerBottom: {
    [DisplayTheme.Light]: BASE_COLORS.stone100,
    [DisplayTheme.Dark]: BASE_COLORS.stone15,
  },
  navBorder: {
    [DisplayTheme.Light]: BASE_COLORS.stone90,
    [DisplayTheme.Dark]: BASE_COLORS.stone25,
  },
  navBackground: {
    [DisplayTheme.Light]: BASE_COLORS['stone99-85'],
    [DisplayTheme.Dark]: BASE_COLORS['stone20-85'],
  },
  reactionBG: {
    [DisplayTheme.Light]: BASE_COLORS.orange70,
    [DisplayTheme.Dark]: BASE_COLORS.orange60,
  },
  progressPrimarySession: {
    [DisplayTheme.Light]: BASE_COLORS.orange50,
    [DisplayTheme.Dark]: BASE_COLORS.orange50,
  },
  progressSecondarySession: {
    [DisplayTheme.Light]: BASE_COLORS['orange50-50'],
    [DisplayTheme.Dark]: BASE_COLORS['orange50-50'],
  },
  progressInsetBorder: {
    [DisplayTheme.Light]: BASE_COLORS.stone100,
    [DisplayTheme.Dark]: BASE_COLORS.stone30,
  },
  shelfCurrentlyReading: {
    [DisplayTheme.Light]: BASE_COLORS.orange50,
    [DisplayTheme.Dark]: BASE_COLORS.orange60,
  },
  shelfWantToRead: {
    [DisplayTheme.Light]: BASE_COLORS.blue50,
    [DisplayTheme.Dark]: BASE_COLORS.blue60,
  },
  shelfFinished: {
    [DisplayTheme.Light]: BASE_COLORS.emerald50,
    [DisplayTheme.Dark]: BASE_COLORS.emerald60,
  },
  shelfDidNotFinish: {
    [DisplayTheme.Light]: BASE_COLORS.stone50,
    [DisplayTheme.Dark]: BASE_COLORS.stone60,
  },
  currentlyReadingRibbon: {
    [DisplayTheme.Light]: BASE_COLORS.orange50,
    [DisplayTheme.Dark]: BASE_COLORS.orange60,
  },
  sampleRibbon: {
    [DisplayTheme.Light]: BASE_COLORS.blue50,
    [DisplayTheme.Dark]: BASE_COLORS.blue60,
  },
  kindleRibbon: {
    [DisplayTheme.Light]: BASE_COLORS.blue50,
    [DisplayTheme.Dark]: BASE_COLORS.blue60,
  },
  finishedRibbon: {
    [DisplayTheme.Light]: BASE_COLORS.emerald50,
    [DisplayTheme.Dark]: BASE_COLORS.emerald60,
  },
  dnfRibbon: {
    [DisplayTheme.Light]: BASE_COLORS.stone50,
    [DisplayTheme.Dark]: BASE_COLORS.stone60,
  },

  buttonBackgroundNeutral: {
    [DisplayTheme.Light]: BASE_COLORS.stone50,
    [DisplayTheme.Dark]: BASE_COLORS.stone50,
  },
  buttonBackgroundNeutralDisabled: {
    [DisplayTheme.Light]: U_ALPHA_LIGHT.uAlphaStone80,
    [DisplayTheme.Dark]: BASE_COLORS.stone10,
  },
  buttonBackgroundNeutralSubtle: {
    [DisplayTheme.Light]: U_ALPHA_LIGHT.uAlphaStone80,
    [DisplayTheme.Dark]: U_ALPHA_DARK.uAlphaStone80,
  },
  buttonBackgroundNeutralSubtleDisabled: {
    [DisplayTheme.Light]: U_ALPHA_LIGHT.uAlphaStone80,
    [DisplayTheme.Dark]: U_ALPHA_DARK.uAlphaStone80,
  },

  buttonBackgroundAccent: {
    [DisplayTheme.Light]: BASE_COLORS.orange50,
    [DisplayTheme.Dark]: BASE_COLORS.orange50,
  },
  buttonBackgroundAccentDisabled: {
    [DisplayTheme.Light]: BASE_COLORS['orange50-50'],
    [DisplayTheme.Dark]: BASE_COLORS['orange50-50'],
  },
  buttonBackgroundAccentSubtle: {
    [DisplayTheme.Light]: U_ALPHA_LIGHT.uAlphaOrange80,
    [DisplayTheme.Dark]: U_ALPHA_DARK.uAlphaOrange80,
  },
  buttonBackgroundAccentSubtleDisabled: {
    [DisplayTheme.Light]: U_ALPHA_LIGHT.uAlphaOrange80,
    [DisplayTheme.Dark]: U_ALPHA_DARK.uAlphaOrange80,
  },

  buttonTextNeutral: {
    [DisplayTheme.Light]: BASE_COLORS.neutral100,
    [DisplayTheme.Dark]: BASE_COLORS.stone00,
  },
  buttonTextNeutralDisabled: {
    [DisplayTheme.Light]: BASE_COLORS['stone65-85'],
    [DisplayTheme.Dark]: BASE_COLORS['stone65-50'],
  },
  buttonTextNeutralSubtle: {
    [DisplayTheme.Light]: BASE_COLORS.stone50,
    [DisplayTheme.Dark]: BASE_COLORS.stone55,
  },
  buttonTextNeutralSubtleDisabled: {
    [DisplayTheme.Light]: BASE_COLORS['stone65-85'],
    [DisplayTheme.Dark]: BASE_COLORS['stone65-50'],
  },

  buttonTextAccent: {
    [DisplayTheme.Light]: BASE_COLORS.neutral100,
    [DisplayTheme.Dark]: BASE_COLORS.stone90,
  },
  buttonTextAccentDisabled: {
    [DisplayTheme.Light]: BASE_COLORS.neutral100,
    [DisplayTheme.Dark]: BASE_COLORS.orange80,
  },
  buttonTextAccentSubtle: {
    [DisplayTheme.Light]: BASE_COLORS.orange50,
    [DisplayTheme.Dark]: BASE_COLORS.orange70,
  },
  buttonTextAccentSubtleDisabled: {
    [DisplayTheme.Light]: BASE_COLORS['orange50-50'],
    [DisplayTheme.Dark]: BASE_COLORS['orange50-50'],
  },

  utilityBlueAlpha50: {
    [DisplayTheme.Light]: '#2d75e53f',
    [DisplayTheme.Dark]: '#2d75e56b',
  },
  utilityBlueAlpha60: {
    [DisplayTheme.Light]: '#2d75e533',
    [DisplayTheme.Dark]: '#2d75e55b',
  },
  utilityBlueAlpha70: {
    [DisplayTheme.Light]: '#2d75e526',
    [DisplayTheme.Dark]: '#2d75e551',
  },
  utilityBlueAlpha80: {
    [DisplayTheme.Light]: '#2d75e519',
    [DisplayTheme.Dark]: '#2d75e53a',
  },
  utilityBlueAlpha90: {
    [DisplayTheme.Light]: '#2d75e50c',
    [DisplayTheme.Dark]: '#2d75e52d',
  },
  utilityEmeraldAlpha50: {
    [DisplayTheme.Light]: '#10b9813f',
    [DisplayTheme.Dark]: '#10b9816b',
  },
  utilityEmeraldAlpha60: {
    [DisplayTheme.Light]: '#10b98133',
    [DisplayTheme.Dark]: '#10b9815b',
  },
  utilityEmeraldAlpha70: {
    [DisplayTheme.Light]: '#10b98126',
    [DisplayTheme.Dark]: '#10b98151',
  },
  utilityEmeraldAlpha80: {
    [DisplayTheme.Light]: '#10b98119',
    [DisplayTheme.Dark]: '#10b9813a',
  },
  utilityEmeraldAlpha90: {
    [DisplayTheme.Light]: '#10b9810c',
    [DisplayTheme.Dark]: '#10b9812d',
  },
  utilityGreenAlpha50: {
    [DisplayTheme.Light]: '#3188353f',
    [DisplayTheme.Dark]: '#3188356b',
  },
  utilityGreenAlpha60: {
    [DisplayTheme.Light]: '#31883533',
    [DisplayTheme.Dark]: '#3188355b',
  },
  utilityGreenAlpha70: {
    [DisplayTheme.Light]: '#31883526',
    [DisplayTheme.Dark]: '#31883551',
  },
  utilityGreenAlpha80: {
    [DisplayTheme.Light]: '#31883519',
    [DisplayTheme.Dark]: '#3188353a',
  },
  utilityGreenAlpha90: {
    [DisplayTheme.Light]: '#3188350c',
    [DisplayTheme.Dark]: '#3188352d',
  },
  utilityNeutralAlpha50: {
    [DisplayTheme.Light]: '#6c78863f',
    [DisplayTheme.Dark]: '#6c78866b',
  },
  utilityNeutralAlpha60: {
    [DisplayTheme.Light]: '#6c788633',
    [DisplayTheme.Dark]: '#6c78865b',
  },
  utilityNeutralAlpha70: {
    [DisplayTheme.Light]: '#6c788626',
    [DisplayTheme.Dark]: '#6c788647',
  },
  utilityNeutralAlpha80: {
    [DisplayTheme.Light]: '#6c788619',
    [DisplayTheme.Dark]: '#6c788633',
  },
  utilityNeutralAlpha90: {
    [DisplayTheme.Light]: '#6c78860c',
    [DisplayTheme.Dark]: '#6c78861e',
  },
  utilityOrangeAlpha50: {
    [DisplayTheme.Light]: '#ff69003f',
    [DisplayTheme.Dark]: '#ff69006b',
  },
  utilityOrangeAlpha60: {
    [DisplayTheme.Light]: '#ff690033',
    [DisplayTheme.Dark]: '#ff69005b',
  },
  utilityOrangeAlpha70: {
    [DisplayTheme.Light]: '#ff690026',
    [DisplayTheme.Dark]: '#ff690051',
  },
  utilityOrangeAlpha80: {
    [DisplayTheme.Light]: '#ff690019',
    [DisplayTheme.Dark]: '#ff69003a',
  },
  utilityOrangeAlpha90: {
    [DisplayTheme.Light]: '#ff69000c',
    [DisplayTheme.Dark]: '#ff69002d',
  },
  utilityRedAlpha50: {
    [DisplayTheme.Light]: '#d8403a3f',
    [DisplayTheme.Dark]: '#d8403a6b',
  },
  utilityRedAlpha60: {
    [DisplayTheme.Light]: '#d8403a33',
    [DisplayTheme.Dark]: '#d8403a5b',
  },
  utilityRedAlpha70: {
    [DisplayTheme.Light]: '#d8403a26',
    [DisplayTheme.Dark]: '#d8403a51',
  },
  utilityRedAlpha80: {
    [DisplayTheme.Light]: '#d8403a19',
    [DisplayTheme.Dark]: '#d8403a3a',
  },
  utilityRedAlpha90: {
    [DisplayTheme.Light]: '#d8403a0c',
    [DisplayTheme.Dark]: '#d8403a2d',
  },
  utilityStoneAlpha50: {
    [DisplayTheme.Light]: '#7b7a793f',
    [DisplayTheme.Dark]: '#7b7a796b',
  },
  utilityStoneAlpha60: {
    [DisplayTheme.Light]: '#7b7a7933',
    [DisplayTheme.Dark]: '#7b7a795b',
  },
  utilityStoneAlpha70: {
    [DisplayTheme.Light]: '#7b7a7926',
    [DisplayTheme.Dark]: '#7b7a7947',
  },
  utilityStoneAlpha80: {
    [DisplayTheme.Light]: '#7b7a7919',
    [DisplayTheme.Dark]: '#7b7a7933',
  },
  utilityStoneAlpha90: {
    [DisplayTheme.Light]: '#7b7a790c',
    [DisplayTheme.Dark]: '#7b7a791e',
  },
  highlightText: {
    [DisplayTheme.Light]: '#161c22',
    [DisplayTheme.Dark]: '#ffffff',
  },
  highlightBackground: {
    [DisplayTheme.Light]: '#f7dc1f26',
    [DisplayTheme.Dark]: '#f7dc1f26',
  },
  highlightBorder: {
    [DisplayTheme.Light]: BASE_COLORS.yellow70,
    [DisplayTheme.Dark]: BASE_COLORS.yellow60,
  },
  highlightTextExternal: {
    [DisplayTheme.Light]: '#323232',
    [DisplayTheme.Dark]: '#323232',
  },
  highlightBackgroundExternal: {
    [DisplayTheme.Light]: '#29313a0c',
    [DisplayTheme.Dark]: '#c1c7cf19',
  },
  highlightBorderExternal: {
    [DisplayTheme.Light]: '#6c7886',
    [DisplayTheme.Dark]: '#8592a0',
  },
  buttonAccentStrongBackground: {
    [DisplayTheme.Light]: '#ff6900',
    [DisplayTheme.Dark]: '#ff6900',
  },
  buttonAccentStrongBackgroundHover: {
    [DisplayTheme.Light]: '#f54900',
    [DisplayTheme.Dark]: '#ff8904',
  },
  buttonAccentStrongBackgroundPressed: {
    [DisplayTheme.Light]: '#ca3500',
    [DisplayTheme.Dark]: '#f54900',
  },
  buttonAccentStrongBackgroundDisabled: {
    [DisplayTheme.Light]: '#ff68007f',
    [DisplayTheme.Dark]: '#ff68007f',
  },
  buttonAccentStrongText: {
    [DisplayTheme.Light]: '#ffffff',
    [DisplayTheme.Dark]: '#323232',
  },
  buttonAccentStrongTextDisabled: {
    [DisplayTheme.Light]: '#ffffff',
    [DisplayTheme.Dark]: '#ffd6a7',
  },
  buttonAccentStrongIcon: {
    [DisplayTheme.Light]: '#ffffff',
    [DisplayTheme.Dark]: '#323232',
  },
  // Button Accent Subtle
  buttonAccentSubtleBackground: {
    [DisplayTheme.Light]: '#ff690019',
    [DisplayTheme.Dark]: '#ff690019',
  },
  buttonAccentSubtleBackgroundHover: {
    [DisplayTheme.Light]: '#ff690026',
    [DisplayTheme.Dark]: '#ff690026',
  },
  buttonAccentSubtleBackgroundPressed: {
    [DisplayTheme.Light]: '#ff690033',
    [DisplayTheme.Dark]: '#ff690033',
  },
  buttonAccentSubtleBackgroundDisabled: {
    [DisplayTheme.Light]: '#ff690019',
    [DisplayTheme.Dark]: '#ff690019',
  },
  buttonAccentSubtleText: {
    [DisplayTheme.Light]: '#ff6900',
    [DisplayTheme.Dark]: '#ffb86a',
  },
  buttonAccentSubtleTextDisabled: {
    [DisplayTheme.Light]: '#ff68007f',
    [DisplayTheme.Dark]: '#ff68007f',
  },
  buttonAccentSubtleIcon: {
    [DisplayTheme.Light]: '#ff6900',
    [DisplayTheme.Dark]: '#ffb86a',
  },
  buttonAccentGhostBackground: {
    [DisplayTheme.Light]: '#ffffff00',
    [DisplayTheme.Dark]: '#00000000',
  },
  buttonAccentGhostBackgroundHover: {
    [DisplayTheme.Light]: '#ff690026',
    [DisplayTheme.Dark]: '#ff690026',
  },
  buttonAccentGhostBackgroundPressed: {
    [DisplayTheme.Light]: '#ff690033',
    [DisplayTheme.Dark]: '#ff690033',
  },
  buttonAccentGhostBackgroundDisabled: {
    [DisplayTheme.Light]: '#ff690019',
    [DisplayTheme.Dark]: '#7b7a7919',
  },
  buttonAccentGhostText: {
    [DisplayTheme.Light]: '#ff6900',
    [DisplayTheme.Dark]: '#ffb86a',
  },
  buttonAccentGhostTextDisabled: {
    [DisplayTheme.Light]: '#ff68007f',
    [DisplayTheme.Dark]: '#ff68007f',
  },
  buttonAccentGhostIcon: {
    [DisplayTheme.Light]: '#ff6900',
    [DisplayTheme.Dark]: '#ffb86a',
  },
  // Button Neutral Strong
  buttonNeutralStrongBackground: {
    [DisplayTheme.Light]: '#7a7a78',
    [DisplayTheme.Dark]: '#7a7a78',
  },
  buttonNeutralStrongBackgroundHover: {
    [DisplayTheme.Light]: '#999895',
    [DisplayTheme.Dark]: '#5d5d5d',
  },
  buttonNeutralStrongBackgroundPressed: {
    [DisplayTheme.Light]: '#b2b0ac',
    [DisplayTheme.Dark]: '#474747',
  },
  buttonNeutralStrongBackgroundDisabled: {
    [DisplayTheme.Light]: '#7b7a7919',
    [DisplayTheme.Dark]: '#7b7a7919',
  },
  buttonNeutralStrongText: {
    [DisplayTheme.Light]: '#ffffff',
    [DisplayTheme.Dark]: '#000000',
  },
  buttonNeutralStrongIcon: {
    [DisplayTheme.Light]: '#ffffff',
    [DisplayTheme.Dark]: '#000000',
  },
  buttonNeutralSubtleBackground: {
    [DisplayTheme.Light]: '#7b7a7919',
    [DisplayTheme.Dark]: '#7b7a7919',
  },
  buttonNeutralSubtleBackgroundHover: {
    [DisplayTheme.Light]: '#7b7a7926',
    [DisplayTheme.Dark]: '#7b7a7926',
  },
  buttonNeutralSubtleBackgroundPressed: {
    [DisplayTheme.Light]: '#7b7a7933',
    [DisplayTheme.Dark]: '#7b7a7933',
  },
  buttonNeutralSubtleBackgroundDisabled: {
    [DisplayTheme.Light]: '#7b7a7919',
    [DisplayTheme.Dark]: '#7b7a7919',
  },
  buttonNeutralSubtleText: {
    [DisplayTheme.Light]: '#7a7a78',
    [DisplayTheme.Dark]: '#7a7a78',
  },
  buttonNeutralSubtleIcon: {
    [DisplayTheme.Light]: '#7a7a78',
    [DisplayTheme.Dark]: '#7a7a78',
  },
  // Button Neutral Ghost
  buttonNeutralGhostBackground: {
    [DisplayTheme.Light]: '#ffffff00',
    [DisplayTheme.Dark]: '#00000000',
  },
  buttonNeutralGhostBackgroundHover: {
    [DisplayTheme.Light]: '#7b7a7926',
    [DisplayTheme.Dark]: '#7b7a7926',
  },
  buttonNeutralGhostBackgroundPressed: {
    [DisplayTheme.Light]: '#7b7a7933',
    [DisplayTheme.Dark]: '#7b7a7933',
  },
  buttonNeutralGhostBackgroundDisabled: {
    [DisplayTheme.Light]: '#7b7a7919',
    [DisplayTheme.Dark]: '#7b7a7919',
  },
  buttonNeutralGhostText: {
    [DisplayTheme.Light]: '#7a7a78',
    [DisplayTheme.Dark]: '#7a7a78',
  },
  buttonNeutralGhostIcon: {
    [DisplayTheme.Light]: '#7a7a78',
    [DisplayTheme.Dark]: '#7a7a78',
  },
  buttonCriticalStrongBackground: {
    [DisplayTheme.Light]: '#ef4444',
    [DisplayTheme.Dark]: '#fca5a5',
  },
  buttonCriticalStrongBackgroundHover: {
    [DisplayTheme.Light]: '#dc2626',
    [DisplayTheme.Dark]: '#f87171',
  },
  buttonCriticalStrongBackgroundPressed: {
    [DisplayTheme.Light]: '#b91c1c',
    [DisplayTheme.Dark]: '#ef4444',
  },
  buttonCriticalStrongBackgroundDisabled: {
    [DisplayTheme.Light]: '#d8403a19',
    [DisplayTheme.Dark]: '#d8403a19',
  },
  buttonCriticalStrongText: {
    [DisplayTheme.Light]: '#ffffff',
    [DisplayTheme.Dark]: '#000000',
  },
  buttonCriticalStrongIcon: {
    [DisplayTheme.Light]: '#ffffff',
    [DisplayTheme.Dark]: '#000000',
  },
  // Button Critical Subtle
  buttonCriticalSubtleBackground: {
    [DisplayTheme.Light]: '#d8403a19',
    [DisplayTheme.Dark]: '#d8403a19',
  },
  buttonCriticalSubtleBackgroundHover: {
    [DisplayTheme.Light]: '#d8403a26',
    [DisplayTheme.Dark]: '#d8403a26',
  },
  buttonCriticalSubtleBackgroundPressed: {
    [DisplayTheme.Light]: '#d8403a33',
    [DisplayTheme.Dark]: '#d8403a33',
  },
  buttonCriticalSubtleBackgroundDisabled: {
    [DisplayTheme.Light]: '#6c788619',
    [DisplayTheme.Dark]: '#6c788619',
  },
  buttonCriticalSubtleText: {
    [DisplayTheme.Light]: '#ef4444',
    [DisplayTheme.Dark]: '#fca5a5',
  },
  buttonCriticalSubtleIcon: {
    [DisplayTheme.Light]: '#ef4444',
    [DisplayTheme.Dark]: '#fca5a5',
  },
  buttonCriticalGhostBackground: {
    [DisplayTheme.Light]: '#ffffff00',
    [DisplayTheme.Dark]: '#00000000',
  },
  buttonCriticalGhostBackgroundHover: {
    [DisplayTheme.Light]: '#d8403a26',
    [DisplayTheme.Dark]: '#d8403a26',
  },
  buttonCriticalGhostBackgroundPressed: {
    [DisplayTheme.Light]: '#d8403a33',
    [DisplayTheme.Dark]: '#d8403a33',
  },
  buttonCriticalGhostBackgroundDisabled: {
    [DisplayTheme.Light]: '#6c788619',
    [DisplayTheme.Dark]: '#6c788619',
  },
  buttonCriticalGhostText: {
    [DisplayTheme.Light]: '#ef4444',
    [DisplayTheme.Dark]: '#fca5a5',
  },
  buttonCriticalGhostIcon: {
    [DisplayTheme.Light]: '#ef4444',
    [DisplayTheme.Dark]: '#fca5a5',
  },
};
